<template>
  <div class="ta-lot-bp-tax-rate">
    <label v-if="label === true" class="ta-lot-bp-tax-rate-label">{{ $t('Buyer\'s Premium') }} &nbsp;</label>
    <label v-else-if="label"  class="ta-lot-bp-tax-rate-label">{{ label }}</label>
    <span v-if="lotObj.auction.premium_terms.length === 1">
      {{lotObj.auction.premium_terms[0].percent}}%
    </span>
    <div v-else v-for="(premium, ind) of lotObj.auction.premium_terms" :key="ind" class="ta-buyer-premium-tier">
      <div class="ta-premium-percent">{{ premium.percent }}% {{ $t('premium') }}</div>
      <div class="ta-premium-over">{{ $t('Over') }} {{ premium.amount_over | asCurrency(lotObj.currency.code) }}</div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "LotAuctionPremium",
  props: {
    label: {
      type: [Boolean, String],
      default: true
    },
    lot: {
      required: false,
      type: [Object, Boolean],
      default: () => false
    },
  },
  computed: {
    ...mapState({lotVuex: state => state.lotObject.data}),
    lotObj() {
      return this.lot || this.lotVuex
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
